import { Component, OnInit, Output, EventEmitter, Input, ViewChild, NgZone, OnChanges, SimpleChanges } from '@angular/core';
import { MainService } from '../services/main-service.service';
import { ProposalService } from '../services/proposal/proposal.service';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { NgForm } from '@angular/forms';
import { ToasterService } from '../services/toaster.service';

@Component({
  selector: 'app-generate-stripe-token',
  templateUrl: './generate-stripe-token.component.html',
  styleUrls: ['./generate-stripe-token.component.scss'],
})
export class GenerateStripeTokenComponent implements OnInit {
  @Output() cardResponse = new EventEmitter<{ token: object, save_card: number }>();
  @Output() onFocussed = new EventEmitter<{ focus: boolean }>();
  @Output() clickParentFunction = new EventEmitter();
  @Input() bankType;
  @Output() triggerParentFunction = new EventEmitter();
  @Output() showElementTrigger = new EventEmitter();
  @Input('address') address: { address_1?: string, city?: string, state?: string, zip?: string, type?: string } = {};
  @Input() buttonClickedSubject;
  @Input() elementId;
  @Input() show_save_card;
  @Input() show_authorization_text;
  @Input() payment_failed_first;
  @Input() payment_failed_this;
  @Input() show_address;
  @Input() backUp_Card: boolean;
  @Input() today_payment_card;
  @Input() recurring_card;
  @Input() web_connect = false;
  @Input() not_Valid;
  @Input() payment_methods;
  @Input() themeChanges;
  @Input() show_only_cvv: boolean = false;
  @Input() selected_card: any;
  @Input() payment_method_type;
  @ViewChild('submit_button') submit_button;
  @ViewChild('clear_button') clear_button;
  save_card_as_Default:boolean = false
  cardName: string;
  zip: any = [];
  cardError: string;
  saveCard: any;
  zip1;
  panel: string = 'request';
  redirect_url: string = '';
  new_address: {
    new_address_1?: string, new_address_2?: string,
    state?: string, zip_code?: string,
    city?: string, checked?: string, country?: string
  } = {};
  contractToken: any;
  pc_code: any;
  cardSelection: any;
  selectValue: any = [];
  paymentCard: any;
  indexShow: any;
  cvvshow: boolean=false;
  card_type: any;
  clickTrue: boolean = false;
  contract_id: number = 0;

  constructor(public mainService: MainService, public zone: NgZone, public toasterService: ToasterService,
    public proposal: ProposalService,
    public route: ActivatedRoute,

  ) { }

  ngOnInit() {
    console.log(this.themeChanges);
    
        if (this.show_only_cvv) {
      this.selectValue = this.payment_methods.filter(item => item.payment_source_type !== 1);
      console.log(this.selectValue);
      if(this.selectValue && this.selectValue.length) {
        this.selectCvcCard(this.selectValue[0], 0);
      }
    }
    this.route.queryParams.subscribe(data => {
      this.contract_id = data.contract_id;
    });
    if (this.show_authorization_text == undefined) {
      this.show_authorization_text = 1;
    }
    this.route.queryParams.subscribe((data: any) => {
      if (data && Object.keys(data).length && data.hasOwnProperty("product_code")) {
        this.pc_code = data.product_code;
        this.proposal.setToken(this.pc_code);
      } else {
        this.route.params.subscribe(param => {
          this.contractToken = param.token;
          this.proposal.setToken(this.contractToken);
        });
      }
    });
    if (this.show_address == undefined) {
      this.show_address = true;
    }
    this.route.queryParams.subscribe((resp: any) => {
      this.redirect_url = resp.redirect_url;
      this.panel = resp.redirect_url && resp.redirect_url.includes("business") ? "business" : "request";
    });
    this.mainService.subject.subscribe(data => {
      if (data) {
        if (this.show_only_cvv) {
          this.ShowCvcElement();
        } else {
          this.ShowStripeElement();
        }
      }
    });

    if (this.mainService.data && this.mainService.data.is_error == 0) {
      if (this.show_only_cvv) {
        this.ShowCvcElement();
      } else {
        this.ShowStripeElement();
      }
    }
    const show_only_cvvs = this.show_only_cvv;
    this.buttonClickedSubject.subscribe(data => {
      if (show_only_cvvs && !this.clickTrue) {
        this.mainService.setLoader(false);
        this.mainService.customPopups('Select your card for payment', 1);
        return;
      }
      // tslint:disable-next-line:max-line-length
      const element_check = show_only_cvvs ? this.mainService.cardCvcElement && this.mainService.cardCvcElement._parent && this.mainService.cardCvcElement._parent.id === this.elementId : this.mainService.stripe_element && this.mainService.stripe_element._parent && this.mainService.stripe_element._parent.id === this.elementId;
      if (element_check && (data === 'add_card' || data === 'add_recurring_card' || data === 'secondary_card' || data === 'recurring_add_card' || data === 'add_new_card' || data === 'add_new_card1' || data === 'iframe_add_card' || data === 'iframe_cvc_card')) {
        if (!show_only_cvvs && data === 'iframe_cvc_card') {
          if (!this.cardSelection || (this.cardSelection && !this.cardSelection.token)) {
            this.mainService.setLoader(false);
            this.mainService.customPopups('Select your card for payment', 1);
            return;
          } else {
            this.submit_button.nativeElement.click();
          }
        } else {
          this.submit_button.nativeElement.click();
        }
      } else if (data === 'clear') {
        if (this.clear_button) {
          this.clear_button.nativeElement.click();
        }
        if (show_only_cvvs) {
          this.mainService.cardCvcElement.clear();
        } else {
          this.mainService.stripe_element.clear();
        }
      }
    });
  }

  selectCards(data) {
    this.paymentCard = data.source_id;
    this.cardSelection = data;
  }

  selectCvcCard(data: any, i) {
    this.clickTrue= true;
    this.mainService.cardCvcElement.unmount('#' + this.elementId);
    this.paymentCard = data.source_id;
    this.cardSelection = data;
    this.cardSelection.cvc_update = true;
    this.indexShow = i;
    console.log(this.cardSelection);
    setTimeout(() => {
      this.mainService.cardCvcElement.mount('#' + this.elementId);
      this.cvvshow = true;
    }, 1000);
    this.cvvshow = false;
  }

  ShowStripeElement() {
    if (document.getElementById('add_card')) {
      this.mainService.stripe_element.mount('#add_card');
    }
    this.mainService.stripe_element.addEventListener('change', ({ data, error }) => {
      if (error) {
        this.cardError = error.message;
      } else {
        this.cardError = '';
      }
    });
    this.mainService.stripe_element.addEventListener('focus', ({ data, error }) => {
      this.focussed();
    });
    this.mainService.stripe_element.addEventListener('ready', ({ data, error }) => {
      this.cardError = '';
    });
  }
  ShowCvcElement() {
    this.mainService.cardCvcElement.addEventListener('change', ({ data, error }) => {
      if (error) {
        this.cardError = error.message;
      } else {
        this.cardError = '';
      }
    });
    this.mainService.cardCvcElement.addEventListener('focus', ({ data, error }) => {
      this.focussed();
    });
    this.mainService.cardCvcElement.addEventListener('ready', ({ data, error }) => {
      this.cardError = '';
    });
  }

  addPaymentSource(obj) {
    this.mainService.setLoader(true);
    obj.save_card = this.save_card_as_Default?1:0
    this.proposal.api('post', 'add_payment_source', this.mainService.urlParams(obj)).subscribe(data => {
      this.mainService.setLoader(false);
      if (!data.is_error) {
        this.cardResponse.emit({token: {}, save_card: 0});
      } else {
        this.mainService.customPopups(data.message || data.err, 1);
        setTimeout(() => {
          this.showElementTrigger.emit(false);
        }, 500);
      }
    });
  }

  confirmPaymentSetUp() {
    // tslint:disable:quotemark
    const errorMessages = [
      "Your card's expiration date is incomplete.",
      'Your card number is incomplete.',
      "Your card's security code is incomplete.",
      "Your postal code is incomplete.",
      "This field is incomplete.",
      "Your ZIP is invalid."
    ];
    if (this.selected_card && this.selected_card.source_id) {
      this.clickParentFunction.emit();
      return;
    }
    if (this.bankType && !this.web_connect && this.elementId !== 'add_card') {
      this.triggerParentFunction.emit();
      return;
    }

    const body = {
      contract_token: this.contractToken ? this.contractToken : undefined,
      pc_code: this.pc_code ? this.pc_code : undefined
    };
    if (this.backUp_Card || this.today_payment_card) {
      body['card_type'] = 'BACKUP';
    }
    this.mainService.setLoader(true);
    this.mainService.stripe.confirmSetup({
      elements: this.mainService.stripePaymentIntent,
      confirmParams: {
        // Make sure to change this to your payment completion page
        return_url: environment.request_panel_link + 'payment-details/' + this.contractToken
      },
      redirect: 'if_required'
    }).then(resp => {
      if (resp.setupIntent && resp.setupIntent.payment_method) {
        if (this.elementId === 'add_card') {
          this.mainService.setLoader(false);
          this.route.queryParams.subscribe(data => {
            const obj = {
              stripe_token: null,
              setup_id: resp.setupIntent.id,
              payment_source_type: 2,
            };
            if(data?.subscription_id) {
              obj['subscription_id'] = data.subscription_id || '';
            }
            if(data?.contract_id) {
              obj['contract_id'] = data.contract_id || '';
            }
            this.addPaymentSource(obj);
          });
          return;
        }
        if (this.recurring_card) {
          this.card_type = 'RECURRING_CARD';
        } else if (this.backUp_Card) {
          this.card_type = 'BACKUP_CARD';
        } else {
          this.card_type = 'TODAY_PAYMENT_CARD';
        }
        const setup_id = resp.setupIntent.id;
        const payment_method = resp.setupIntent.payment_method;
        const params = {
          payment_method_id: payment_method
        };
        if (this.backUp_Card || this.web_connect || this.recurring_card || this.today_payment_card) {
          // tslint:disable-next-line:max-line-length
          this.mainService.get_Payment_method_intent(params, setup_id, this.saveCard, this.cardResponse, { cardType: this.card_type }, this.payment_method_type);
        } else {
          const confirmPaymentIntent = this.CreateAndConfirmPaymentIntent(setup_id, this.contractToken, this.pc_code);
          confirmPaymentIntent.then((result) => {
            if (result && result['paymentIntent'] && result['paymentIntent']['id']) {
              // tslint:disable-next-line:max-line-length
              this.mainService.get_Payment_method_intent(params, setup_id, this.saveCard, this.cardResponse, { paymentIntentId: result['paymentIntent']['id'], cardType: this.card_type });
            } else {
              this.mainService.setLoader(false);
              this.mainService.saveFinancingError({ payment_intent_id: setup_id, contract_token: this.contractToken, error_message: result['error'].message, error_type: "confirmPaymentSetUp", patient_id: this.mainService.patient_id, pc_code: this.pc_code, contract_id: this.contract_id, panel: this.panel });
              this.mainService.customPopups(result['error'].message, 1);
              this.showElementTrigger.emit(false);
            }
          }).catch((error) => {
            this.mainService.setLoader(false);
            if (error) {
              this.mainService.saveFinancingError({ payment_intent_id: setup_id, contract_token: this.contractToken, error_message: error.error.message, error_type: "confirmPaymentSetUp", patient_id: this.mainService.patient_id, pc_code: this.pc_code, contract_id: this.contract_id, panel: this.panel });
              this.mainService.customPopups(error.error.message, 1);
            }
            this.showElementTrigger.emit(false);
          });
        }
      } else {
        if (resp.error && resp.error.message) {
          this.mainService.customPopups(resp.error.message, 1);
        }
        this.mainService.setLoader(false);
        console.log(errorMessages.includes(resp.error.message));
        if (resp.error && !errorMessages.includes(resp.error.message)) {
          this.showElementTrigger.emit(false);
        }
        this.mainService.saveFinancingError({ payment_intent_id: "dummyIntent", contract_token: this.contractToken, error_message: resp.error['message'], error_type: "confirmPaymentSetUp", patient_id: this.mainService.patient_id, pc_code: this.pc_code, contract_id: this.contract_id, panel: this.panel });
      }
  });
  }


  addCard(form: NgForm) {
    if (this.cardError) {
      this.toasterService.message(this.cardError, 3);
      return;
    }
    if (this.new_address.new_address_1 && this.new_address.new_address_1.trim().length == 0) {
      this.toasterService.message('Address line 1 cannot be empty', 2);
      return;
    }
    if (form.value.cardName || this.cardName) {
      // tslint:disable-next-line:max-line-length
      if ((form.value.cardName && form.value.cardName.trim().length == 0) || (this.cardName && this.cardName.length > 0 && String(this.cardName).trim().length == 0)) {
        this.toasterService.message('Please fill card holder name', 3);
        return;
      }
    }
    if (!form.valid && !this.not_Valid) {
      this.toasterService.message('Please Add/Select a valid payment source.', 3);
      return;
    } else {
      const data = {
        name: form.value.cardName || this.cardName,
        address_city: "",
        address_line1: "",
        address_line2: "",
        address_zip: "",
        state: "",
        address_country: "",
        address_state: ""
      };
      this.cardError = '';
      if (!this.new_address.checked) {
        data['address_line1'] = this.new_address.new_address_1;
        data['address_line2'] = this.new_address.new_address_2 ? this.new_address.new_address_2 : '';
        data['address_city'] = this.new_address.city;
        data['address_state'] = this.new_address.state;
        data['address_zip'] = String(this.new_address.zip_code);
        data['address_country'] = this.new_address.country;
      } else {
        data['address_line1'] = this.address.address_1;
        data['address_city'] = this.address.city;
        data['address_state'] = this.address.state;
        data['address_zip'] = String(this.address.zip);
        data['address_country'] = this.address['country_code'] || 'US';
      }
      if (this.show_address && this.show_address != 'false') {
        // tslint:disable-next-line:max-line-length
        if (!this.new_address.checked && !(data['address_line1'] && data['address_city'] && data['address_state'] && data['address_zip'] && data['address_country'])) {
          return;
        }
      }
      this.mainService.setLoader(true);

      let clientSecret;

      const body = {
        contract_token: this.contractToken ? this.contractToken : undefined,
        pc_code: this.pc_code ? this.pc_code : undefined
      };

      if (this.backUp_Card || this.today_payment_card) {
        body['card_type'] = 'BACKUP';        
      }
      
      this.proposal.api('post', 'separate_paymentmethod_intent', this.mainService.urlParams(body)).subscribe((intent_data: any) => {
        if (intent_data && intent_data.is_error) {
          this.mainService.flagPopUps(intent_data.flag, intent_data.err);
        } else {
          clientSecret = intent_data.setup_client_secret;
          this.mainService.stripe.confirmCardSetup(
            clientSecret, {
            payment_method: {
              card: this.mainService.stripe_element,
              billing_details: {
                name: data.name,
                address: {
                  "city": data.address_city,
                  "country": data.address_country,
                  "line1": data.address_line1,
                  "line2": data.address_line2,
                  "postal_code": data.address_zip,
                  "state": data.address_state
                }
              }
            }
          }).then((result) => {
            if (result.error) {
              this.mainService.setLoader(false);
              this.zone.run(_ => {
                if (typeof result.error == 'string') {
                  this.cardError = result.error;
                } else {
                  this.cardError = result.error && result.error.message;
                }
              });
            } else {
              let setup_id = result.setupIntent.id;
              let payment_method = result.setupIntent.payment_method;

              const params = {
                payment_method_id: payment_method
              };

              if (this.recurring_card) {
                this.card_type = 'RECURRING_CARD';
              } else if (this.backUp_Card) {
                this.card_type = 'BACKUP_CARD';
              } else {
                this.card_type = 'TODAY_PAYMENT_CARD';
              }

              if (this.backUp_Card || this.web_connect || this.recurring_card || this.today_payment_card) {
                this.mainService.get_Payment_method_intent(params, setup_id, this.saveCard, this.cardResponse, { cardType: this.card_type });
              } else {
                const confirmPaymentIntent = this.CreateAndConfirmPaymentIntent(setup_id, this.contractToken, this.pc_code);
                confirmPaymentIntent.then((result) => {
                  if ( result && result['paymentIntent'] && result['paymentIntent']['id'] ) {


                    this.mainService.get_Payment_method_intent(params, setup_id, this.saveCard, this.cardResponse, { paymentIntentId: result['paymentIntent']['id'], cardType: this.card_type });                    
                  }else{
                    this.mainService.setLoader(false);
                    this.mainService.customPopups(result['error'].message, 1);
                  }
                }).catch((error) => {
                  this.mainService.setLoader(false);
                  if (error) {
                    this.mainService.customPopups(error.error.message, 1);
                  }
                });
              }

            }
          });
        }
      });
    }
  }
  getZip(zip_code) {
    if (zip_code === '') {
      this.zip = [];
      return false;
    }
    if (zip_code && zip_code.length > 3) {
      this.mainService.getZipcode({ zipcode: zip_code })
        .subscribe((data: any) => {
          this.zip = data.zip_info;

        }, (error: any) => {
        });
    }
  }

  selectZip(zip) {
    if (this.zip && this.zip.length > 0) {
      var zip_data = this.zip.filter(item => item.city_id == zip)[0] ? this.zip.filter(item => item.city_id == zip)[0] : [];
      this.new_address.zip_code = (zip_data && zip_data.zip) || '';
      this.new_address.state = (zip_data && zip_data.state_name) || '';
      this.new_address.city = (zip_data && zip_data.city) || '';
      this.new_address.country = (zip_data && zip_data.country_code) || 'US';
    }
    // this.zip1 = this.new_address.zip_code
  }
  zipClear() {
    this.new_address.zip_code = null;
    this.new_address.state = null;
    this.new_address.city = null;
    this.new_address.country = null;
  };

  focussed() {
    this.onFocussed.emit({ focus: true })
  }

  createCvcToken(data) {
    let _this = this;
    this.mainService.stripe.createToken('cvc_update',
      this.mainService.cardCvcElement,
    ).then((result) => {
      if (result.error) {
        _this.mainService.setLoader(false);
        _this.zone.run(_ => {
          if (typeof result.error == 'string') {
            _this.cardError = result.error;
          } else {
            _this.cardError = result.error && result.error.message;
          }
        });
      } else {
        let cvc_token = result.token.id;
        const params = {
          payment_method_id: this.cardSelection.token,
        };
        // tslint:disable-next-line:max-line-length
        const resp = _this.mainService.get_Payment_method_intent(params, this.cardSelection.source_id, _this.saveCard, _this.cardResponse, { cardSelection: this.cardSelection, cvc_token: cvc_token });
        // resp.then((cardData: any) => {
        //   if (cardData && cardData.token) {
        //     _this.cardResponse.emit(cardData);
        //   }
        // });
      }
    }).catch((error) => {

    })
  }


  async CreateAndConfirmPaymentIntent(setup_id, contractToken, pc_code) {
    return new Promise((resolve, reject) => {
      const body = {
        setup_id: setup_id,
        contract_token: contractToken,
        pc_code: pc_code
      };

      this.proposal.api('post', 'create_payment_intent_add_card', this.mainService.urlParams(body)).subscribe((paymentIntent) => {
        if (paymentIntent.is_error == 0) {
          // tslint:disable-next-line:max-line-length
          if (paymentIntent.funding && !this.mainService.paymentMethodValidation(this.bankType == 1 ? 'Bank' : 'Card', paymentIntent.funding)) {
            this.showElementTrigger.emit(false);
            reject(false);
          } else {
            const clientSecret = paymentIntent.payment_intent_client_secret;
            const nextAction = this.confirmPayment(clientSecret);
            nextAction.then((confirmPaymentIntent) => {
                resolve(confirmPaymentIntent);
            }).catch((err) => {
              this.showElementTrigger.emit(false);
              this.mainService.setLoader(false);
              reject(err);
            });
          }
        } else {
          this.mainService.setLoader(false);
          this.showElementTrigger.emit(false); +
            this.mainService.saveFinancingError({ payment_intent_id: setup_id, contract_token: contractToken, error_message: paymentIntent.err, error_type: "CreateAndConfirmPaymentIntent", contract_id: this.contract_id, panel: this.panel });
          this.mainService.customPopups(paymentIntent.err, 1);
        }
      });
    });
  }

  // async handleNextAction(client_secret) {
  //   return new Promise((resolve, reject) => {
  //     this.mainService.stripe.handleNextAction(
  //       { clientSecret: client_secret }
  //     ).then((res) => {
  //       resolve(res);
  //     }).catch((err) => {
  //       this.mainService.setLoader(false);
  //       reject(err);
  //     });
  //   });
  // }

  async confirmPayment(client_secret) {
    return new Promise((resolve, reject) => {
      this.mainService.stripe.confirmPayment(
        {
          clientSecret: client_secret,
          // confirmParams: {
          //   // Make sure to change this to your payment completion page
          //   // return_url: window.location.href
          // },
          redirect: 'if_required'
        }
      ).then((res) => {
        resolve(res);
      }).catch((err) => {
        reject(err);
        this.mainService.setLoader(false);
      });
    });
  }
}
